import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import { MediaPickerField } from "./MediaPickerField";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type CardProps = {
  title: string;
  text: string;
  imageSrc?: string;
  imageMediaId?: string | null;
  buttonLabel?: string;
  buttonHref?: string;
};

export function CardBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<CardProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <MediaPickerField
          label="Image"
          value={{ mediaId: props.imageMediaId ?? null, url: props.imageSrc ?? null, altText: null }}
          onChange={(sel) =>
            setProp((p) => {
              p.imageMediaId = sel.mediaId;
              p.imageSrc = sel.url ?? "";
            })
          }
        />
        <div className="space-y-1">
          <Label className="text-xs">Title</Label>
          <Input className="h-8 text-xs" value={props.title ?? ""} onChange={(e) => setProp((p) => { p.title = e.target.value; })} />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Text</Label>
          <Textarea className="text-xs" rows={2} value={props.text ?? ""} onChange={(e) => setProp((p) => { p.text = e.target.value; })} />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Button label</Label>
          <Input className="h-8 text-xs" value={props.buttonLabel ?? ""} onChange={(e) => setProp((p) => { p.buttonLabel = e.target.value; })} />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Button link</Label>
          <Input className="h-8 text-xs" value={props.buttonHref ?? ""} onChange={(e) => setProp((p) => { p.buttonHref = e.target.value; })} />
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBorderRadius />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
